export default class Cache {
  constructor() {
    this._cache = {};
    this._sizeInBytes = 0;
  }

  get(imageId) {
    if (!this._cache[imageId]) {
      return undefined;
    }
    return this._cache[imageId];
  }

  set(imageId, data) {
    this._cache[imageId] = data;
  }

  /**
   * 영상 데이터가 Cache에 로드되어있는지 확인
   * @param {string} imageId
   */
  has(imageId) {
    return this._cache[imageId] !== undefined;
  }

  //get keys(){
  get_keys() {
    return Object.keys(this._cache);
  }

  // remove the cached/loaded dicom dataset for the specified wadouri to free up memory
  del(uri) {
    if (this._cache[uri]) {
      //this._sizeInBytes -= this._cache[uri].dataSet.length;
      delete this._cache[uri];
    }
  }

  getInfo() {
    return {
      //cacheSizeInBytes,
      numberOfDataSetsCached: Object.keys(this._cache).length
    };
  }

  // removes all cached datasets from memory
  clear() {
    this._cache = {};
  }
}
